<ng-container *transloco="let convert;">
  <div class="modal--action-list" role="dialog" aria-modal="true" [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.actionListMessageModal.ariaLabelMessageModal')">

    <h1 class="modal__title" id="action-list-message-modal-title" tabindex="-1">
      <div class="container">
        @if (headerMessage != '') {
          <div class="row">
            <div class="col-12 text-start">
              @if (errorMessages.length === 0) {
                <span>
                  <app-check-icon class="check-mark" fill="#0B8100"></app-check-icon>
                </span>
              }
              {{headerMessage}}
            </div>
          </div>
        }
      </div>
    </h1>

    <div class="modal__body pt-1">
      <div class="container">
        @for (error of errorMessages; track error) {
          <div class="row pb-1">
            <div class="col-1">
              <app-error-icon [fill]="'#d42925'"></app-error-icon>
            </div>
            <div class="col-11">
              <p class="text-break" [innerHtml]="error"></p>
            </div>
          </div>
        }

        <div class="row">
          <div class="col-12">
            <p class="text-break mb-0" [innerHtml]="successMessage"></p>
          </div>
        </div>
        <div class="modal__actions">
          <button class="btn btn-primary me-md-2 mb-3 mb-md-0" [attr.aria-label]="convert('common.btnClose')"
                  allytmln="Close"
                  (click)="closeModal()">
            <span>{{convert('common.btnClose')}}</span>
          </button>
        </div>
      </div>
    </div>

    @if (configuration$()) {
      <button class="modal__close" data-dismiss="modal" [attr.aria-label]="convert('common.modalClose')" (click)="closeModal()"
              data-track-elem="icon" data-track-name="Close" data-track-trigger="close">
        <img src="../../../../../ui/assets/assets-{{ configuration$().tenantName }}/{{ configuration$().tenantName }}-close.svg"
             alt="{{convert('common.altCloseModelIcon')}}" />
      </button>
    }
  </div>
</ng-container>
